var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34 27.49a5.44 5.44 0 1 0 0 .5 3.77 3.77 0 0 0 0-.5zm-6.4 2.36v-1h-1a.83.83 0 1 1 0-1.67h1v-1a.83.83 0 0 1 1.67 0v1h1a.83.83 0 1 1 0 1.67h-1v1a.83.83 0 0 1-1.67 0z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.66 2.45H8.4a3.34 3.34 0 0 0-3.34 3.33v2.5H2.83a.83.83 0 1 0 0 1.67h4.46a.83.83 0 1 1 0 1.67H5.06v5.55H2.83a.83.83 0 1 0 0 1.67h4.46a.83.83 0 1 1 0 1.67H5.06v5.55H2.83a.83.83 0 1 0 0 1.67h4.46a.83.83 0 1 1 0 1.67H5.06v.83a3.33 3.33 0 0 0 3.34 3.32h15.4A7.22 7.22 0 1 1 34 23.4V5.78a3.35 3.35 0 0 0-3.34-3.33zM25.1 14.39H14a.83.83 0 1 1 0-1.67h11.1a.83.83 0 1 1 0 1.67z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumber);
export default __webpack_public_path__ + "static/media/phone_number.0db0a4eb5e79d80f18536712c530791c.svg";
export { ForwardRef as ReactComponent };